import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TornadoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tornado"}/>
}
